module.exports = __webpack_public_path__ + "img/Admission.79bfea72.png";